import Alpine from 'alpinejs';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
// webpack etc fiddles with the urls so this makes sure the marker appears as needed
// https://github.com/PaulLeCam/react-leaflet/issues/453
import icon from 'leaflet/dist/images/marker-icon.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';
let DefaultIcon = L.icon({
    iconUrl: icon,
    shadowUrl: iconShadow
});
L.Marker.prototype.options.icon = DefaultIcon;

// core version + navigation, pagination modules:
import SwiperCore, { Navigation, Pagination, Swiper, Autoplay, Thumbs, Keyboard } from 'swiper/core';
import 'swiper/swiper.min.css';
// configure Swiper to use modules
SwiperCore.use([Navigation, Pagination, Autoplay, Thumbs, Keyboard]);

const HOME_SLIDE_DELAY = 5000;

window.Alpine = Alpine;
// wait for alpine to init
document.addEventListener('alpine:init', () => {
    Alpine.store('modals', {
        activeModal: null,
        setActiveModal(modalKey) {
            this.activeModal = modalKey;
        },
        init() {
            Alpine.effect(() => {
                if (this.activeModal === null) {
                    let html = document.querySelector('html');
                    html.classList.remove('overflow-hidden');
                } else {
                    let html = document.querySelector('html');
                    html.classList.add('overflow-hidden');
                }
            })
    
            window.addEventListener('keyup', (e) => {
                const { key } = e;
                if (this.activeModal !== null) {
                    if (key === 'Escape') {
                        this.activeModal = null;
                    }
                }
            })
        }
    })

    Alpine.store('sellingTabs', {
        activeTab: 'valuing'
    })
    
    Alpine.data('map', (lat,lng) => {
        return {
            map: null,
            init() {
                let map = this.$refs.map;
                this.map = L.map(map).setView([lat,lng],17);
                let OpenStreetMapLayer = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                    maxZoom: 19,
                    attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                });
                let marker = L.marker([lat,lng]);
                OpenStreetMapLayer.addTo(this.map);
                marker.addTo(this.map);
            }
        }
    })

    Alpine.data('ViewSwitcher', (currentView = 'row') => {
        return {
            activeView: currentView,
            init() {
                this.$watch('activeView', (newVal) => {
                    let params = new URLSearchParams(window.location.search);
                    params.set('view', newVal);
                    window.location.search = params.toString();
                })
            }
        }
    })
})

Alpine.start();

document.addEventListener('DOMContentLoaded', () => {
    const homeSlider = new Swiper('.js-home-slider', {
        loop: true,
        autoplay: {
            delay: HOME_SLIDE_DELAY,
            disableOnInteraction: false,
            pauseOnMouseEnter: false
        },
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
            bulletClass: 'h-1 w-8 bg-white bg-opacity-30 cursor-pointer hover:bg-opacity-80',
            bulletActiveClass: 'bg-opacity-100'
        }
    })
    
    const sellingValuingSlider = new Swiper('.js-selling-valuing-slider', {
        loop: true,
        autoplay: true,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
            bulletClass: 'h-1 w-8 bg-dark-100 bg-opacity-30 cursor-pointer hover:bg-opacity-80',
            bulletActiveClass: 'bg-opacity-100'
        }
    })

    const listingsSlider = document.querySelectorAll('.js-listings-slider');

    if (listingsSlider) {
        listingsSlider.forEach(sliderEl => {
            const listingsSliderPagination = sliderEl.querySelector('.js-listings-swiper-pagination');
            const listingsSliderNext = sliderEl.querySelector('.js-listings-swiper-next');
            const listingsSliderPrev = sliderEl.querySelector('.js-listings-swiper-prev');
            const sliderContainer = sliderEl.querySelector('.js-listings-slider-container');

            new Swiper(sliderContainer, {
                slidesPerGroup: 1,
                slidesPerView: 1,
                spaceBetween: 16,
                breakpoints: {
                    420: {
                        slidesPerGroup: 2,
                        slidesPerView: 2,
                        spaceBetween: 32,
                    },
                    1024: {
                        slidesPerGroup: 4,
                        slidesPerView: 4
                    }
                },
                navigation: {
                    nextEl: listingsSliderNext,
                    prevEl: listingsSliderPrev,
                    hiddenClass: 'hidden',
                    disabledClass: 'hidden'
                },
                pagination: {
                    el: listingsSliderPagination,
                    clickable: true,
                    bulletClass: 'h-1 w-8 bg-dark-100 bg-opacity-30 cursor-pointer hover:bg-opacity-80',
                    bulletActiveClass: 'bg-opacity-100'
                }
            })
        })
    }

    const gallerySlider = new Swiper('.js-gallery-slider', {
        loop: true,
        navigation: {
            nextEl: '.gallery-next-btn',
            prevEl: '.gallery-prev-btn',
            hiddenClass: 'hidden',
            disabledClass: 'hidden'
        }
    })

    const galleryThumbnailsSlider = new Swiper('.js-gallery-thumbnails', {
        freeMode: true,
        slidesPerView: 5,
        spaceBetween: 10,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        slideActiveClass: 'opacity-100',
        breakpoints: {
            768: {
                slidesPerView: 10
            },
            1024: {
                slidesPerView: 25
            }
        }
    })
    
    const galleryPopupPrev = document.querySelector('.js-gallery-popup-prev-btn');
    const galleryPopupNext = document.querySelector('.js-gallery-popup-next-btn');
    const galleryPopupSlider = new Swiper('.js-gallery-popup-slider', {
        loop: true,
        keyboard: {
            enabled: true
        },
        navigation: {
            nextEl: galleryPopupNext,
            prevEl: galleryPopupPrev,
            hiddenClass: 'hidden',
            disabledClass: 'hidden'
        },
        thumbs: {
            swiper: galleryThumbnailsSlider
        }
    })

    jQuery(".checkbox").on("click", function () { 
       var $checkbox = jQuery(this).find(':checkbox');
       if ( $checkbox.is("#for-let") || $checkbox.is("#include-let") ) {
        jQuery("#for-sale").prop('checked', false);
        jQuery("#include-sold").prop('checked', false);
        jQuery("#minimum_price").hide();
        jQuery("#maximum_price").hide();
        jQuery("#minimum_rent").show();
        jQuery("#maximum_rent").show();
        jQuery(".price-range").text('Price Range (rent)');
        jQuery("#department").val('residential-lettings');
       }
       if ( $checkbox.is("#for-sale") || $checkbox.is("#include-sold") ) {
        jQuery("#for-let").prop('checked', false);
        jQuery("#include-let").prop('checked', false);
        jQuery("#minimum_price").show();
        jQuery("#maximum_price").show();
        jQuery("#minimum_rent").hide();
        jQuery("#maximum_rent").hide();
        jQuery(".price-range").text('Price Range');
        jQuery("#department").val('residential-sales');
       }
    });

})
